import { Types } from 'service-api'
import { Box, Stack, Typography, Skeleton, Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import { isConsumable } from 'membership/helper'

const StyledBox = styled(Box)(({ theme }) => ({
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: 180,
  flex: '0 0 180px',
  padding: theme.spacing(2),
  border: `1px solid ${theme.palette.background.darkGrey}`,
  borderRadius: theme.spacing(1),
  overflow: 'hidden',
}))

const StyledText = styled(Typography)(({ theme }) => ({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  maxWidth: '100%',
  textOverflow: 'ellipsis',
  display: 'block',
  marginBottom: theme.spacing(1),
}))

export const BenefitConsumption = ({
  currentBenefits,
  currentBenefitsUsage,
  isLoading,
  hideConsumptionNumbers,
}: {
  currentBenefits?: Types.BenefitAdminDto[] | Types.BenefitClientDto[]
  currentBenefitsUsage?: Types.BenefitConsumptionRecordAdminDto[] | Types.BenefitConsumptionRecordClientDto[]
  isLoading?: boolean
  hideConsumptionNumbers?: boolean
}) => {
  const limitedBenefits = currentBenefits?.filter((benefit) => isConsumable(benefit.type))
  if (isLoading) {
    return (
      <>
        <Stack direction="row" gap={1} my={2} flexWrap="wrap">
          <Skeleton width={170} height={95} variant="rounded" />
          <Skeleton width={170} height={95} variant="rounded" />
          <Skeleton width={170} height={95} variant="rounded" />
        </Stack>
      </>
    )
  }
  return (
    <>
      <Stack direction="row" gap={1} my={2} flexWrap="wrap">
        {limitedBenefits?.map((benefit) => {
          const offers = benefit.benefitOffers?.map((benefitOffer) => benefitOffer?.offer?.displayName).join(', ')
          const consumedBenefitsQty = currentBenefitsUsage?.filter(
            (benefitUsage) => benefitUsage.benefit?.id === benefit.id
          )
          return (
            <StyledBox key={benefit.id}>
              <Tooltip title={offers}>
                <StyledText variant="body1bold">{offers}</StyledText>
              </Tooltip>
              <Typography variant="h5">
                {hideConsumptionNumbers ? '-' : `${consumedBenefitsQty?.length}/${benefit.qty}`}
              </Typography>
            </StyledBox>
          )
        })}
      </Stack>
    </>
  )
}
